import React from "react";

const CONFIG = {
  // Order statuses
  pending: { label: "Pending", cls: "bg-amber-500/15 text-amber-300 border-amber-500/25" },
  processing: { label: "Processing", cls: "bg-blue-500/15 text-blue-300 border-blue-500/25" },
  completed: { label: "Completed", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/25" },
  partial: { label: "Partial", cls: "bg-purple-500/15 text-purple-300 border-purple-500/25" },
  canceled: { label: "Canceled", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25" },
  cancelled: { label: "Canceled", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25" },
  refunded: { label: "Refunded", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25" },
  failed: { label: "Failed", cls: "bg-red-500/15 text-red-300 border-red-500/25" },
  // Topup statuses
  waiting_payment: { label: "Menunggu", cls: "bg-amber-500/15 text-amber-300 border-amber-500/25" },
  approved: { label: "Approved", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/25" },
  rejected: { label: "Rejected", cls: "bg-red-500/15 text-red-300 border-red-500/25" },
  paid: { label: "Paid", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/25" },
  expired: { label: "Expired", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25" },
};

export const StatusBadge = ({ status, testid }) => {
  const key = String(status || "").toLowerCase();
  const cfg = CONFIG[key] || { label: status || "-", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25" };
  return (
    <span
      data-testid={testid}
      className={`inline-block text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-md border ${cfg.cls}`}
    >
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
